const crypto = require('crypto');

export function ServiceIORest(options) {

  options = Object.assign({
    apiPath: '/api/',

    client_id: '',
    client_screet: '',

    // persistCredentials: '',

    // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
    // xsrfCookieName: 'XSRF-TOKEN', // default

    // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
    // xsrfHeaderName: 'X-XSRF-TOKEN'
    xcreHeaderName: 'x-cre-token', // credential to persist to localstorage and get back on token request
    xcidHeaderName: 'x-cid-token',
    xsrfHeaderName: 'x-xsrf-token',
    // xjwtatHeaderName: 'x-jwt-token',
    xjwtatHeaderName: 'x-jwt-at',
    xjwtrtHeaderName: 'x-jwt-rt',
    xcaptchaHeaderName: 'x-captcha-token',

    xseHeaderName: 'x-se',

    jwtAccessToken: '',
    jwtRefreshToken: '',
    jwt: null,

    savedCredentials: null,

    unauthorizedStatus: [401, 403],

    onCredentials: function (type, token) {
      /**
       * type: access_token, refresh_token
       * token
       */
    },

    onUnauthorized: function () {

    }

  }, options);

  /**
   * Generate unauthorizedStatus lookup
   */
  if (Array.isArray(options.unauthorizedStatus)) {
    const unauthorizedStatusLookup = {};
    for (var i = 0; i < options.unauthorizedStatus.length; i++) {
      const method = options.unauthorizedStatus[i];
      unauthorizedStatusLookup[method] = true;
    }
    options.unauthorizedStatus = unauthorizedStatusLookup;
  }

  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
    // Authorization: undefined, // 'Bearer '
  };

  function setHeader(key, value) {
    // if (typeof value != 'undefined') {
    if (value) {
      headers[key] = value;
    } else {
      delete headers[key];
    }
  }

  function setClientID(id) {
    // options.client_id = id;
    setHeader(options.xcidHeaderName, id);
  }

  // function setClientSecret(secret) {
  // 	options.client_screet = secret;
  // }

  function parseJWT(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    } catch (e) {
      return null;
    }
  };

  function setAuthorizationToken(credentials, type = 'Bearer') {
    setHeader('Authorization', credentials ? type + ' ' + credentials : null);
    options.jwt = credentials ? parseJWT(credentials) : null;
    if (options.savedCredentials) {
      setHeader(options.xcreHeaderName, null);
    }
    options.onCredentials('access_token', credentials);
    // console.log('JWT', options.jwt);
  }

  function persistCredentials(data) {
    if (data) {
      localStorage.setItem(options.xcreHeaderName, data);
    } else {
      localStorage.removeItem(options.xcreHeaderName);
    }
  }

  function setCaptchaToken(token) {
    setHeader(options.xcaptchaHeaderName, token);
  }

  function getXSRFToken() {
    return {
      name: options.xsrfHeaderName,
      value: headers[options.xsrfHeaderName]
    };
  }

  function request(url, payload = {}, method = 'GET') {

    const needPayload = method === 'POST';

    // console.log('HEAD', headers);

    return fetch(url, {
      method,

      cache: 'no-cache',

      credentials: 'same-origin',

      headers,

      // redirect: 'follow',

      // body: needPayload ? JSON.stringify(signKey !== '*' && encKey !== '*' ? {
      //   'x-payload': enc_sign(payload)
      // } : payload) : undefined,

      body: needPayload ? JSON.stringify({
        'x-payload': enc_sign(payload)
      }) : undefined,

    })
      .then(response => {

        let token = response.headers.get(options.xsrfHeaderName);
        if (token) {
          setHeader(options.xsrfHeaderName, token);
        }

        token = response.headers.get(options.xcidHeaderName);
        if (token) {
          setClientID(token);
        }

        token = response.headers.get(options.xjwtatHeaderName);
        if (token) {
          options.jwtAccessToken = token;
          setAuthorizationToken(token);
          // options.onCredentials('access_token', token);
        }

        token = response.headers.get(options.xjwtrtHeaderName);
        if (token) {
          options.jwtRefreshToken = token;
          options.onCredentials('refresh_token', token);
        }

        if (response.headers.has(options.xcreHeaderName)) {
          token = response.headers.get(options.xcreHeaderName);
          persistCredentials(token);
          setHeader(options.xcreHeaderName, null);
        }

        token = response.headers.get(options.xseHeaderName);

        // console.log(response.headers)
        if (token) {
          const values = token.split('.');

          // console.log(values);
          setKeys(values[0], values[1]);
        }

        // console.log('HEAD >>', url, headers);

        if (options.unauthorizedStatus[response.status]) {
          // unauthroized
          setTimeout(options.onUnauthorized, 300);
        }

        const contentType = response.headers.get('content-type');

        if (contentType && contentType.includes('application/json')) {
          return response.json().then(data => {
            // return {
            // 	code: response.ok ? 0 : response.status,
            // 	payload: data
            // }

            // for compatibility
            return data;
          });
        } else {
          return response.text().then(data => {

            // return {
            // 	code: response.ok ? 0 : response.status,
            // 	payload: data
            // }

            // for compatibility
            return data;
          });
        }
      });
    // .catch(err => {
    // 	return {
    // 		code: 500,
    // 		payload: err.toString()
    // 	}
    // })
  }

  /**
   * Load encrypted token from localstorage (later decoded by server using an session key)
   */
  options.savedCredentials = localStorage.getItem(options.xcreHeaderName);
  if (options.savedCredentials) {
    setHeader(options.xcreHeaderName, options.savedCredentials);
  }

  function deleteAllCookies() {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

  const algo = 'aes-256-cbc';
  let signKey = '2a3b7fbb-2d1d-4f77-868a-11cd7eb37a27';
  let encKey = '9e9bf6b0-fe39-40d2-a38b-a5dcb5c05c18';

  function sign(text) { //}, secret = signKey) {
    return text + '.' + crypto
      .createHmac('sha256', signKey)
      .update(text)
      .digest('base64')
      .replace(/\=+$/, '');
  }

  function encrypt(val) { //, secret = encKey) {
    const cipher = crypto.createCipher(algo, encKey),
      crypted = cipher.update(typeof val == 'object' ? JSON.stringify(val) : val, 'utf8', 'base64');
    return crypted + cipher.final('base64').replace(/\=+$/, '');
  }

  function enc_sign(data) {
    return sign(encrypt(data));
  }

  function setKeys(sign, enc) {
    signKey = sign;
    encKey = enc;

    // console.log('SET', signKey, encKey)
  }

  return {
    // options,

    setHeader,
    setClientID,
    // setClientSecret,
    setAuthorizationToken,
    setCaptchaToken,
    getXSRFToken,

    jwt() {
      return options.jwt;
    },

    crypto: {
      sign,
      encrypt,
      enc_sign,
      setKeys
    },

    reset() {
      options.jwtAccessToken = '';
      options.jwtRefreshToken = '';
      options.jwt = null;
      persistCredentials(null);
      setHeader(options.xcreHeaderName, null);
      options.onCredentials('access_token', null);

      deleteAllCookies();
    },

    get(path) {
      return request(path[0] != '/' ? options.apiPath + path : path);
    },

    post(path, payload) {
      return request(path[0] != '/' ? options.apiPath + path : path, payload, 'POST');
    },

    call(path, payload) {
      return request(path[0] != '/' ? options.apiPath + path : path, payload, 'POST');
    }
  };
}